<app-modal-notification #confirmation></app-modal-notification>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="col-12 modal-title text-center">
      <ng-container i18n="button|The button text for booking an appointment.@@buttonScheduleVisit">Book a session</ng-container>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="bookingForm" (ngSubmit)="onSubmit()">
      <div class="zaya-form-header" i18n="header|Indicates where the user will fill their information details.@@headerYourInformation">Your information</div>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="firstName" class="zaya-form-sub-header" i18n="label|The first name of a user.@@labelFirstName">First name</label>
            <input type="text" class="form-control" formControlName="firstName">
            <span
              class="help-block"
              *ngIf="bookingForm.get('firstName').invalid && bookingForm.get('firstName').touched"
              i18n="error message|The message shown when a first name has not been entered.@@errorFirstName">
                Please enter a valid first name.
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="firstName" class="zaya-form-sub-header" i18n="label|The last name of a user.@@labelLastName">Last name</label>
            <input type="text" class="form-control" formControlName="lastName">
            <span
              class="help-block"
              *ngIf="bookingForm.get('lastName').invalid && bookingForm.get('lastName').touched"
              i18n="error message|The message shown when a last name has not been entered.@@errorLastName">
                Please enter a valid last name.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="email" class="zaya-form-sub-header" i18n="label|The email of a user.@@labelEmail">Email</label>
            <input type="email" class="form-control" formControlName="email">
            <span
              class="help-block"
              *ngIf="bookingForm.get('email').invalid && bookingForm.get('email').touched"
              i18n="error message|The message shown when an email has not been entered.@@errorEmail">
                Please enter a valid email.
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="phoneNumber" class="zaya-form-sub-header" i18n="label|The phone number of a user.@@labelPhoneNumber">Phone number</label>
            <input type="tel" class="form-control" formControlName="phoneNumber">
            <span
              class="help-block"
              *ngIf="bookingForm.get('phoneNumber').invalid && bookingForm.get('phoneNumber').touched"
              i18n="error message|The message shown when a phone number has not been entered.@@errorPhone">
                Please enter a valid phone number.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="referredBy" class="zaya-form-sub-header" i18n="label|Indicates how a user was made aware of the application.@@labelReferred">How'd you hear about us?</label>
            <input type="text" class="form-control" formControlName="referredBy">
            <span
              class="help-block"
              *ngIf="bookingForm.get('referredBy').invalid && bookingForm.get('referredBy').touched"
              i18n="error message|The message shown when a referral reason has not been entered.@@errorReferral">
                Please enter a valid referral.
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="preferredContact" class="zaya-form-sub-header" i18n="label|How a user should be communicated with.@@labelContact">How do you want to be contacted?</label>
            <div class="input-group">
              <select id="preferredContact" class="form-control" formControlName="preferredContact">
                <option value="phone" i18n="label|Phone number.@@labelPhone">Phone</option>
                <option value="email" i18n="label|Email.@@labelEmail">Email</option>
              </select>
            </div>
            <span
              class="help-block"
              *ngIf="bookingForm.get('preferredContact').invalid && bookingForm.get('preferredContact').touched"
              i18n="error message|The message shown when a contact (communication) has not been entered.@@errorContact">
                Please enter a valid contact.
            </span>
          </div>
        </div>
      </div>

      <hr>
      <div class="zaya-form-header" i18n="header|Indicates where the user will fill their reason to schedule a visit.@@headerReason">Reason for visit</div>

      <div class="row">
        <div class="col-md-12">
          <div formArrayName="services">
            <div class="zaya-form-sub-header" style="margin-bottom: 10px;" i18n="label|The practitioner services the user has selected.@@labelServiceSelected">Service selected</div>
            <div class="form-group" *ngFor="let valueControl of _getControls('services'); let i = index;">
              <div class="input-group">
                <select class="form-control" [formControlName]="i">
                  <option *ngFor="let serviceVal of allTherapies" [value]="serviceVal.name">{{serviceVal.name}}</option>
                </select>
              </div>
              <span
                class="help-block"
                *ngIf="i == 0 && bookingForm.get('services.0').invalid && bookingForm.get('services.0').touched"
                i18n="error message|The message shown when a service has not been selected.@@errorService">
                  Please select at least 1 service.
              </span>
              <div class="text-right" *ngIf="i > 0">
                <span class="zaya-form-link" (click)="_onRemoveControl('services', i)">x <ng-container i18n="button|Indicates how to remove a selection.@@buttonRemove">Remove</ng-container></span>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-bottom: 10px;">
            <span class="zaya-form-link" (click)="_onAddControl('services')">+ <ng-container i18n="button|Indicates how to add a service.@@buttonAddService">Add another service</ng-container></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="description" class="zaya-form-sub-header" i18n="label|The reason a user is scheduling a visit.@@labelReason">Please tell us the reason for your visit</label>
            <textarea type="text" class="form-control" id="description" rows="4" formControlName="description"></textarea>
            <span
              class="help-block"
              *ngIf="bookingForm.get('description').invalid && bookingForm.get('description').touched"
              i18n="error message|The message shown when a reason has not been selected.@@errorReason">
                Please enter a valid reason.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="bookingType" class="zaya-form-sub-header" i18n="label|The type of booking that is requested.@@labelBookingType">What type of session do you prefer?</label>
            <div class="input-group">
              <select id="bookingType" class="form-control" formControlName="bookingType">
                <option [value]="type" *ngFor="let type of bookingTypes">{{type}}</option>
              </select>
            </div>
            <span
              class="help-block"
              *ngIf="bookingForm.get('bookingType').invalid && bookingForm.get('bookingType').touched"
              i18n="error message|The message shown when a booking type has not been selected.@@errorBookingType">
                Please enter a valid booking type.
            </span>
          </div>
        </div>
      </div>
      <div formGroupName="requestedDates">
        <div class="row" *ngFor="let _ of _getControls('requestedDates.dates'); let i = index;">
          <div class="col-xs-12 col-md-6" formArrayName="dates">
            <div class="form-group">
              <label for="date{{i}}" class="zaya-form-sub-header" i18n="label|The date a user would like to request a service for.@@labelDateRequested">Date requested</label>
              <input type="text" ngbDatepicker #d="ngbDatepicker" class="form-control" [formControlName]="i" (click)="d.toggle()"/>
              <span
                class="help-block"
                *ngIf="bookingForm.get('requestedDates.dates.' + i).invalid && bookingForm.get('requestedDates.dates.' + i).touched"
                i18n="error message|The message shown when a date has not been selected.@@errorDate">
                  Please enter a valid date.
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6" formArrayName="times">
            <div class="form-group">
              <label for="time{{i}}" class="zaya-form-sub-header" i18n="label|The time of day a user would like to request a service for.@@labelTimeRequested">Time of day</label>
              <div class="input-group">
                <select id="time{{i}}" class="form-control" [formControlName]="i">
                  <option [value]="time" *ngFor="let time of bookingTimes">{{time}}</option>
                </select>
              </div>
              <span
                class="help-block"
                *ngIf="bookingForm.get('requestedDates.times.' + i).invalid && bookingForm.get('requestedDates.times.' + i).touched"
                i18n="error message|The message shown when a time of day has not been selected.@@errorTime">
                  Please enter a valid time of day.
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="error">
      <hr>
      <div class="alert alert-danger">
        <span>{{error}}</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="d-flex flex-fill justify-content-center">
      <button
        gaEvent
        gaCategory="Booking Form"
        [gaAction]="'Booking scheduled'"
        [gaLabel]="'click'"
        type="submit"
        class="btn btn-primary schedule-btn"
        [disabled]="bookingForm.invalid || disableSubmit"
        (click)="onSubmit()"
        i18n="button|Text to indicate an user booking a service.@@schedule">Schedule</button>
      <app-loader *ngIf="isLoading"></app-loader>
    </div>
  </div>
</ng-template>
